import { render, staticRenderFns } from "./PetugasTcTambah.vue?vue&type=template&id=b29a8da8&scoped=true&"
import script from "./PetugasTcTambah.vue?vue&type=script&lang=js&"
export * from "./PetugasTcTambah.vue?vue&type=script&lang=js&"
import style0 from "./PetugasTcTambah.vue?vue&type=style&index=0&id=b29a8da8&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29a8da8",
  null
  
)

export default component.exports